import Utils from '../../Utils.js';

export async function handleHtmlPaste(data, position) {
  const htmlContent = await data.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const extractedText = doc.body.textContent || "";
  Utils.insertSticky({ text: extractedText, position });
}